import aavyaTheme from '@aavya/theme/index';
import $ from 'jquery';

export default function () {
    var productPage = document.querySelector('#shopify-section-product');
    const indexPage = document.querySelector('#featured-collection');
    if (productPage) {
        var arrow = '<svg fill="#000000" viewBox="0 0 129 129"><path d="M121.3 34.6c-1.6-1.6-4.2-1.6-5.8 0l-51 51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8 0-1.6 1.6-1.6 4.2 0 5.8l53.9 53.9c.8.8 1.8 1.2 2.9 1.2 1 0 2.1-.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2.1-5.8z"/></svg>';
        var actionSlides = function actionSlides() {
            return aavyaTheme.slickSlider.create($('#actionSlides'), {
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                infinite: true,
                centerMode: true,
                centerPadding: '0px',
                swipeToSlide: true,
                prevArrow: arrow,
                nextArrow: arrow,
                responsive: [{
                    breakpoint: 767,
                    settings: "unslick"
                }]
            });
        };

        aavyaTheme.slickSlider.create($('#thumbs'), {
            focusOnSelect: true,
            slidesToShow: 4,
            slidesToScroll: 0,
            arrows: true,
            prevArrow: arrow,
            nextArrow: arrow,
            dots: false,
            asNavFor: '#productImages',
            vertical: true
            //verticalSwiping: true,
        });

        aavyaTheme.slickSlider.create($('#productImages'), {
            mobileFirst: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            infinite: true,
            centerMode: true,
            centerPadding: '0px',
            swipeToSlide: true,
            prevArrow: arrow,
            nextArrow: arrow,
            asNavFor: '#thumbs',
            responsive: [{
                breakpoint: 768,
                settings: {
                    arrows: false
                }
            }]
        });

        var $slides = actionSlides();
        $(window).resize(function (e) {
            if (window.innerWidth < 767) {
                if (!$slides.hasClass('slick-initialized')) {
                    actionSlides();
                }
            }
        });

        // @TODO: refactor
        var tables = document.querySelectorAll('[data-table]');
        if (tables.length > 1) {
            var fitment = tables[0];
            var dimensions = tables[1];
            var rows = dimensions.querySelectorAll('tbody tr td');

            fitment.querySelectorAll('thead tr td')[0].classList.add('is-selected');
            dimensions.querySelectorAll('thead tr td')[1].classList.add('is-selected');

            for (var i = 0; i < rows.length; i++) {
                rows[i].setAttribute('colspan', '2');
            }

            fitment.querySelectorAll('thead tr td')[1].onclick = function () {
                fitment.classList.add('is-hidden');
                dimensions.classList.remove('is-hidden');
            };
            dimensions.querySelectorAll('thead tr td')[0].onclick = function () {
                dimensions.classList.add('is-hidden');
                fitment.classList.remove('is-hidden');
            };
        }
    }
    if (indexPage) {
        const arrow = '<svg fill="#000000" viewBox="0 0 129 129"><path d="M121.3 34.6c-1.6-1.6-4.2-1.6-5.8 0l-51 51.1-51.1-51.1c-1.6-1.6-4.2-1.6-5.8 0-1.6 1.6-1.6 4.2 0 5.8l53.9 53.9c.8.8 1.8 1.2 2.9 1.2 1 0 2.1-.4 2.9-1.2l53.9-53.9c1.7-1.6 1.7-4.2.1-5.8z"/></svg>';
        aavyaTheme.slickSlider.create($('#featured-product-list'), {
          mobileFirst: true,
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true,
          infinite: true,
          centerMode: true,
          centerPadding: '0px',
          swipeToSlide: true,
          prevArrow: arrow,
          nextArrow: arrow,
          responsive: [
            {
              breakpoint: 680,
              settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
              },
            },
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 4,
                slidesToScroll: 1,
              },
            },
          ],
        });
      }
};
